import { AssetProperties, initialAsset } from '../../asset/types/asset.type';
import {
  DeviceTypeProperties,
  initialDeviceType,
} from '../../deviceType/types/device.type';

export enum EDeviceType {
  GPS = 'gps',
  FLOWMETER = 'flowmeter',
  RPM = 'rpm',
  CLUTCH = 'clutch',
  AE = 'ae',
  GATEWAY = 'gateway',
  POWER_SUPPLY = 'power_supply',
  BUNKER = 'bunker',
  PANEL_DOOR = 'panel_door',
}

export interface IDeviceMetadata {
  aeFuelConstanta: number;
  aeFuelType: string;
}

export type DeviceProperties = {
  deviceId: string;
  uniqueId: string;
  name: string;
  isRamus2?: boolean;
  status: string;
  deviceTypeId: string;
  description?: string;
  createdByUserId: string;
  userCreator?: {
    name?: string | null;
    firstName?: string | null;
    middleName?: string | null;
    lastName?: string | null;
  };
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
  assetId: string;
  asset: AssetProperties;
  cloneData?: {
    assetId: string;
    name: string;
  };
  deviceType: DeviceTypeProperties;
  metadata?: IDeviceMetadata;
};

export function resolveOriginalDeviceAssetId(
  asset:
    | {
        assetId?: string;
        aliasId?: string | null;
        metadata?: { ramusMigration?: unknown } | null;
      }
    | undefined,
  selectedAssetId: string,
) {
  const aliasId = String(asset?.aliasId || '').trim();
  if (!asset || !aliasId || asset.metadata?.ramusMigration) {
    return selectedAssetId;
  }

  return aliasId;
}

export const initialDevice: DeviceProperties = {
  deviceId: '',
  name: '',
  uniqueId: '',
  deviceTypeId: '',
  status: '',
  createdByUserId: '',
  assetId: '',
  asset: { ...initialAsset },
  deviceType: { ...initialDeviceType },
};

export interface ICreateDevice {
  name: string;
  uniqueId: string;
  deviceType: string;
  status: string;
  assetId: string;
  description?: string;
  createdByUserId: string;
  aeFuelConstanta?: string;
  aeFuelType?: string;
}
